/*
 * @Description: 事业群设置
 * @Author: 杨志航
 * @Date: 2026-08-31 16:11:45
 */
import update from 'immutability-helper'
import React, { useCallback, useState, useEffect } from 'react'
import api from 'api'
import {
  Alert,
  message,
  Drawer,
} from 'antd'
import { parseSearch } from '@/utils'
import EditGroup from '../../../module/EditGroup'
import DraggableTable from '@/components/DraggableTable'

const Main = props => {
  const { location, history } = props
  const search = parseSearch(location.search)
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})

  useEffect(() => {
    getList()
  }, [])

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getProfitReportGroupSort({
      companyId: search.id
    }).then(data => {
      setList(data)
      setCount(data.length)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  const moveRow = useCallback((dragIndex, hoverIndex) => {
    const dragRow = list[dragIndex]
    const newData = update(list, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRow],
      ],
    })
    setList(newData)
  }, [list])

  const handleSort = () => {
    const ids = list.map(item => item.groupId)
    setLoading(true)
    api.updateProfitReportGroupSort({ 
      companyId: search.id,
      id: ids 
    }).then(() => {
      message.success('排序成功')
      getList()
    }).catch(() => getList())
  }

  const onEdit = record => {
    setEditData(record)
    setEditVisible(true)
  }

  const columns = [
    {
      title: '排序',
      dataIndex: 'sort',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'OA事业群名称',
      dataIndex: 'groupName',
    },
    {
      title: '小程序事业群名称',
      dataIndex: 'name',
    },
    {
      title: 'OA事业群负责人',
      dataIndex: 'groupLeaderName',
    },
    {
      title: '小程序事业群负责人',
      dataIndex: 'leaderName',
    },
    {
      title: '下级部门数量',
      dataIndex: 'departmentNum',
    },
    {
      title: '在职主账号人数',
      dataIndex: 'personNum',
    },
    {
      title: '操作',
      key: 'set',
      fixed: 'right',
      align: 'center',
      width: 180,
      render: (text, record) => (
        <>
          <a onClick={() => onEdit(record)}>事业群设置</a>
          <a onClick={() => history.push(`/ach/profit/companysetting/groupsetting/departsetting?id=${record.gdid}`)} style={{ marginLeft: 8 }}>部门详情</a>
        </>
      ),
    },
  ]

  return (
    <>
      <Alert className="corp-count" message={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>总共{count}条数据</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleSort}>保存排序</span>
        </div>
      } type="info" showIcon />
      <DraggableTable
        rowKey={(_, index) => index}
        size="small"
        dataSource={list}
        columns={columns}
        pagination={false}
        loading={loading}
        moveRow={moveRow}
      />
      <Drawer
        title="事业群设置"
        width={600}
        onClose={() => setEditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <EditGroup editData={editData} setVisible={setEditVisible} getList={getList} />
      </Drawer>
    </>
  )
}
export default Main